namespace $ {

	/** Optional bulk-write preflight. Actual writers still validate routing/readiness. */
	export class $shm_hitalama_map_history_preparation extends $mol_object {

		history() { return null! as $shm_hitalama_map_history }

		private prepared = false

		@ $mol_mem_key
		private index( key: string ) {
			const history = this.history()
			const [ commands, shard ] = key.split( ':' )
			const namespace = commands === '1' ? 'history-commands' : 'history-index'
			const land = history.land().area_make( $mol_hash_string( `${ history.link().str }:${ namespace }:${ shard }` ) )
			const index = land.Data( $shm_hitalama_map_history_storage_index )
			index.units()
			this.$.$shm_hitalama_map_history_storage_ready.settled( index )
			return index
		}

		@ $mol_mem
		prepare() {
			if( this.prepared ) return true
			let pending: PromiseLike<unknown> | undefined
			// Start a bounded wave before waiting. Never mutate registry entries,
			// skip routing, or treat pending as an empty partition.
			for( let commands = 0; commands < 2; ++commands ) {
				for( let shard = 0; shard < $shm_hitalama_map_history.storage_index_shards; ++shard ) {
					try { this.index( `${ commands }:${ shard }` ) }
					catch( error ) {
						if( !$mol_promise_like( error ) ) throw error
						pending ??= error
					}
				}
			}
			if( pending ) $mol_fail_hidden( pending )
			this.prepared = true
			return true
		}

	}

}
